module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/profile/user-uploads/timeline.jpg";